import type { MissionAction, WeeklyMissionTask } from '../api';

// Match the catalog identity and its exact title shape; never strip arbitrary user text.
const catalogTitles: Record<string, { metric?: string; title: RegExp }> = {
  'action:meal_log': { metric: 'meal_days', title: /^🥗\s+(留下\d+天完整三餐记录)$/ },
  'action:move_gently': { metric: 'exercise_minutes', title: /^🚶\s+(记录累计\d+分钟活动)$/ },
  'action:move_moderately': { metric: 'exercise_days', title: /^🚶\s+(记录\d+天适合自己的活动)$/ },
  'action:strength': { metric: 'exercise_sessions', title: /^💪\s+(记录\d+次适量力量练习)$/ },
  'action:exercise_log': { metric: 'exercise_sessions', title: /^📝\s+(留下一次运动记录)$/ },
  'dim:intellect:note-count': { metric: 'note_count', title: /^📝\s+(留下\d+条笔记)$/ },
  'dim:craft:study-days': { metric: 'study_days', title: /^📚\s+(留下\d+天学习记录)$/ },
  'dim:heart:recovery-pause': { title: /^🌿\s+(给自己5分钟放松)$/ },
  'dim:bond:meaningful-contact': { title: /^💬\s+(主动联系一个想联系的人)$/ },
  'dim:purpose:next-step': { title: /^🎯\s+(确定一个可完成的小步骤)$/ },
};

export function missionTaskTitle(task: WeeklyMissionTask): string {
  const template = task.template_key ? catalogTitles[task.template_key] : undefined;
  if (!template || (template.metric && (task.verification !== 'auto' || task.rule?.metric !== template.metric))) return task.title;
  return task.title.match(template.title)?.[1] || task.title;
}

export function missionAction(task: WeeklyMissionTask): MissionAction {
  if (task.action) return task.action;
  const metric = task.rule?.metric || '';
  if (metric === 'meal_days') return { type: 'meal', label: '去记饮食' };
  if (metric.startsWith('exercise_')) return { type: 'exercise', label: '去记运动' };
  if (metric === 'note_count') return { type: 'note', label: '去写笔记' };
  if (metric === 'study_days') return { type: 'study', label: '继续学习' };
  return { type: 'manual', label: '查看任务' };
}

export function missionProgressLabel(task: WeeklyMissionTask): string {
  if (task.progress?.label) return task.progress.label;
  if (task.progress) return `${task.progress.current} / ${task.progress.target} ${task.progress.unit}`;
  if (task.verification === 'auto' && task.rule) return `目标 ${task.rule.target} ${task.rule.unit} · 按记录自动更新`;
  return task.verification === 'auto' ? '按实际记录自动更新' : '完成后手动确认';
}

export function sortMissionTasks(tasks: WeeklyMissionTask[]): WeeklyMissionTask[] {
  return tasks.filter(task => !task.archived || task.status === 'completed').slice().sort((a, b) =>
    Number(a.status === 'completed') - Number(b.status === 'completed')
    || Number(!!a.archived) - Number(!!b.archived)
    || (b.priority ?? 0) - (a.priority ?? 0));
}
